import { render, staticRenderFns } from "./agentChainOfThought.vue?vue&type=template&id=caa8bd04&scoped=true&"
import script from "./agentChainOfThought.vue?vue&type=script&lang=js&"
export * from "./agentChainOfThought.vue?vue&type=script&lang=js&"
import style0 from "./agentChainOfThought.vue?vue&type=style&index=0&id=caa8bd04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa8bd04",
  null
  
)

export default component.exports